import type { MouseEvent } from 'react';

/**
 * True when a click on a link should be handled by the client-side router:
 * primary button, no modifier key (new tab / window / download stay native).
 */
export function isPlainLeftClick(event: MouseEvent<HTMLElement>): boolean {
  return (
    !event.defaultPrevented
    && event.button === 0
    && !event.metaKey
    && !event.altKey
    && !event.ctrlKey
    && !event.shiftKey
  );
}
